module.exports = __webpack_public_path__ + "static/img/9.f0244dd5.png";